// frontend/src/utils/apiHelpers.js
// Centralized API helper functions for secure API calls

/**
 * Get API base URL with validation
 * @returns {string} API base URL
 */
export const getApiBaseUrl = () => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  if (!baseURL) {
    throw new Error("API configuration error");
  }
  return baseURL;
};

/**
 * Get authentication headers with token validation
 * Redirects to login if token is missing
 * @returns {Object} Headers object with Authorization token
 */
export const getAuthHeaders = () => {
  const token = localStorage.getItem("ogestyle_token");
  if (!token) {
    window.location.href = "/login";
    return {};
  }
  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
};

/**
 * Validate if a redirect URL is safe (starts with /dashboard/)
 * @param {string} path - Path to validate
 * @returns {boolean} Whether the path is safe
 */
export const isValidDashboardPath = (path) => {
  return path && path.startsWith("/dashboard/");
};

/**
 * Validate if an external URL is from Stripe
 * @param {string} url - URL to validate
 * @returns {boolean} Whether the URL is from Stripe
 */
export const isValidStripeUrl = (url) => {
  try {
    const urlObj = new URL(url);
    return urlObj.hostname.endsWith(".stripe.com");
  } catch {
    return false;
  }
};
